<template>
  <div>

    <v-layout 
    :class="['mrow hoverable unselectable', {'pt-2 pb-2 pr-2': widgetMode === 2}, {'widget-mode-3': widgetMode === 3}, {'active': localSelected.includes(item.id)}]"
    :style="`padding-left: ${tier*20}px;`"
     align-center @click="localOnClick" >
      <v-icon v-if="sortedChildren.length > 0 && expandable" small :class="{'rotate-90': expand}">
        mdi-chevron-right
      </v-icon>
      <div v-else style="flex: 0 0 16px;">

      </div>

      <v-icon small>
        mdi-label
      </v-icon>

      <v-btn
      v-if="widgetMode !== 2 && widgetMode !== 3"
      icon
      small
      @click.stop="checkRow(item)">
        <v-icon small :color="localSelected.includes(item.id) ? 'color1' : ''"> 
          {{ localSelected.includes(item.id) ? 'check_box' : 'check_box_outline_blank' }}
        </v-icon>
      </v-btn>
      <div v-else style="flex: 0 0 8px;">

      </div>
      

      <div v-if="!renameMode" class="text-truncate">
        {{ item.name }}
      </div>
      <div v-else style="flex: 1;">
        <v-text-field
        v-model="renameTextView"
        hide-details
        class="pt-0"
        ref="renameTextField"
        color="color1"
        @focus="$event.target.select()"
        @blur="localRenameItem"
        @keydown.enter="localRenameItem"
        ></v-text-field>
      </div>

      <!--
      <span class="label ml-2">
        ({{ (item.children || []).length }})
      </span>
      -->
       <template v-if="editable">
        <v-btn v-if="!showNewRow"
        color="color1"
        icon small @click.stop="clickAddItem">
          <v-icon small>add</v-icon>
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="color1"
              @click.stop
              v-on="on"
            >
              <v-icon small>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
            @click="clickRename">
              <v-list-item-title>Rename</v-list-item-title>
            </v-list-item>
            <v-list-item
            @click="deleteRow">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

       </template>
    </v-layout>

    <v-expand-transition>
      <div v-if="expand">
        <div>
          <v-layout v-if="showNewRow"
          :style="`padding-left: ${(tier+1)*20}px;`"
          align-center>

            <div style="flex: 0 0 16px;">

            </div>

            <v-icon small color="color1">
              mdi-label
            </v-icon>

            <div style="flex: 0 0 40px;">

            </div>

            <!--
            <v-text-field
            v-model="newItemTitle"
            hide-details
            class="pt-0"
            ref="textField"
            color="color1"
            @keydown.enter="localCreateNewItem"
            @blur="delayedBlur"
            ></v-text-field>
            -->

            <v-textarea 
            v-model="newItemTitle" 
            label="description"
            color="text"
            ref="textField">
            </v-textarea>
            
            <v-btn v-if="newItemTitle"
            text
            small
            color="color1"
            class="ml-2 white--text" @click="localCreateNewItem">
              Create
            </v-btn>
            <v-btn v-else
            icon
            small
            class="ml-2 white--text" color="color1" @click="showNewRow = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>

          </v-layout>
          <row 
          v-for="child in sortedChildren" 
          :key="child.id"
          :createNewItem="createNewItem"
          :tier="tier+1"
          :widgetMode="widgetMode"
          :renameItem="renameItem"
          :onDelete="onDelete"
          :editable="editable"
          :selected.sync="localSelected"
          :onClick="onClick"
          :item="child">
          </row>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'row',
  props: {
    item: null,
    widgetMode: null,
    tier: null,
    onClick: null,
    createNewItem: null,
    renameItem: null,
    onDelete: null,
    selected: null,
    editable: null
  },
  data () {
    return {
      expand: true,
      showNewRow: false,
      renameMode: false,
      renameTextView: '',
      newItemTitle: ''
    }
  },
  computed: {
    localSelected: {
      get () {
        return this.selected
      },
      set (nv) {
        this.$emit('update:selected', nv)
      }
    },
    expandable () {
      return this.widgetMode !== 2
    },
    sortedChildren () {
      return this.item.children.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
    }
  },
  methods: {
    localRenameItem () {
      this.renameItem(this.item, this.renameTextView)
      this.renameMode = false
    },
    localCreateNewItem () {
      this.createNewItem(this.newItemTitle, this.item)
      this.showNewRow = false
      this.newItemTitle = ''
    },
    clickAddItem () {
      this.expand = true
      this.showNewRow = true
      this.$nextTick(() => {
        this.$refs.textField.focus()
      })
      console.log('clicked')
    },
    clickRename () {
      this.renameTextView = this.item.name
      this.renameMode = true
      this.$nextTick(() => {
        this.$refs.renameTextField.focus()
      })
    },
    checkRow (item) {
      if (this.localSelected.includes(item.id)) {
        var index = this.localSelected.indexOf(item.id)
        this.localSelected.splice(index, 1);
      } else {
        this.localSelected.push(item.id)
      }
      // Vue.set(this.selected, item.tempID, !this.selected[item.tempID])
    },
    deleteRow () {
      this.onDelete([this.item.id])
    },
    delayedBlur () {
      setTimeout(() => {
        this.showNewRow = false
      }, 150)
    },
    localOnClick () {
      if (this.widgetMode === 2) {
        this.onClick(this.item)
      } else if (this.widgetMode === 3) {
        this.localSelected = [this.item.id]
      } else if (this.expandable) {
        this.expand = !this.expand
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mrow {
  cursor: pointer;
  &.hoverable {
    &:hover {
      background: var(--v-backgroundHover-base);
    }
  }
  &.widget-mode-3 {
    border-radius: 0px 80px 80px 0px;
    padding: 8px 8px 8px 0px;
    &:hover {
      background: var(--v-backgroundHover-base);
    }
    &.active {
      background: var(--v-backgroundHover-base);
    }
  }
}
</style>

